import { render, staticRenderFns } from "./TenYears.vue?vue&type=template&id=38a29806&scoped=true&"
import script from "./TenYears.vue?vue&type=script&lang=js&"
export * from "./TenYears.vue?vue&type=script&lang=js&"
import style0 from "./TenYears.vue?vue&type=style&index=0&id=38a29806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a29806",
  null
  
)

export default component.exports